﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { ProtectedRoute } from "~base/Components/Pages/Shared/ProtectedRoute";
import { LoginPage } from "~base/Components/Pages/Account/Login";
import { LogoutPage } from "~base/Components/Pages/Account/Logout";
import { AccessDeniedPage } from "~base/Components/Pages/Account/AccessDenied";
import { NotFoundPage } from "~base/Components/Pages/Home/NotFound";
import { EndSessionPage } from "~prad/Components/Pages/Home/EndSession";
import { ExternalLoginPage } from "~base/Components/Pages/Account/ExternalLogin";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPageCustomization from "~prad/Components/Pages/Account/Login";
import LogoutPageCustomization from "~prad/Components/Pages/Account/Logout";
import StartPageCustomization from "~prad/Components/Pages/Home/Start";
import AccessDeniedPageCustomization from "~prad/Components/Pages/Account/AccessDenied";
import { StartPage } from "~base/Components/Pages/Home/Start";
import { ExternalLoginByCookieCallbackPage } from "~base/Components/Pages/Account/ExternalLoginByCookieCallback";
import type { PageRouteInfo } from "~base/Components/Pages/Shared/PageRoute";
import { createPageRoute } from "~base/Components/Pages/Shared/PageRoute";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

type MainRouterProps = {
    children?: React.ReactNode;
};

//-------------------------------------------------------------------------------------
// Routes
//-------------------------------------------------------------------------------------

const account: PageRouteInfo[] = [
    {
        path: "Account/Login/*",
        component: <LoginPage customizations={LoginPageCustomization} />,
    },
    {
        path: "Account/Logout/*",
        component: <LogoutPage customizations={LogoutPageCustomization} />,
    },
    {
        path: "Account/AccessDenied/*",
        component: (
            <AccessDeniedPage customizations={AccessDeniedPageCustomization} />
        ),
    },
    {
        path: "Account/Forbidden/*",
        component: (
            <AccessDeniedPage customizations={AccessDeniedPageCustomization} />
        ),
    },
    {
        path: "Account/ExternalLoginCallback/*",
        component: <ExternalLoginPage />,
    },
    {
        path: "Account/ExternalLoginByCookieCallback/*",
        component: <ExternalLoginByCookieCallbackPage />,
    },
];

const home: PageRouteInfo[] = [
    {
        path: "Home/Start/*",
        component: (
            <ProtectedRoute>
                <StartPage customizations={StartPageCustomization} />
            </ProtectedRoute>
        ),
    },
    { path: "Home/EndSession/*", component: <EndSessionPage /> },
    {
        path: "/",
        component: (
            <ProtectedRoute>
                <StartPage customizations={StartPageCustomization} />
            </ProtectedRoute>
        ),
    },
    { path: "/*", component: <NotFoundPage /> },
];

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

export const MainRouter: React.FunctionComponent<MainRouterProps> = (
    props: MainRouterProps
) => {
    return (
        <BrowserRouter>
            <Routes>
                {account.map((x) => createPageRoute(x))}
                {home.map((x) => createPageRoute(x))}
            </Routes>
        </BrowserRouter>
    );
};
